// Is the manually-entered card complete and plausibly valid?
//
// This gates the AddPaymentInfo pixel, which should mean "the visitor supplied a
// usable payment method" — not "typed one digit and left". It is deliberately
// the same standard a gateway applies before it will even attempt a charge:
// Luhn-valid number, an expiry in the future, a CVV of the right length.

// Luhn checksum — catches transposed digits and filler like 4111 1111 1111 1112.
const luhnValid = (digits) => {
	let sum = 0;
	let double = false;
	for (let i = digits.length - 1; i >= 0; i--) {
		let d = Number(digits[i]);
		if (double) {
			d *= 2;
			if (d > 9) d -= 9;
		}
		sum += d;
		double = !double;
	}
	return sum % 10 === 0;
};

export const cardNumberValid = (value) => {
	const digits = String(value || '').replace(/\D/g, '');
	// 15 for Amex, 16 for the rest; the input mask stops at 16.
	if (digits.length !== 15 && digits.length !== 16) return false;
	return luhnValid(digits);
};

export const expirationValid = (value) => {
	const match = /^(\d{2})\/(\d{2})$/.exec(String(value || '').trim());
	if (!match) return false;
	const month = Number(match[1]);
	const year = 2000 + Number(match[2]);
	if (month < 1 || month > 12) return false;
	const now = new Date();
	// A card is good through the last day of its expiry month.
	const endOfMonth = new Date(year, month, 1);
	return endOfMonth > now;
};

export const cvvValid = (value) => {
	const digits = String(value || '').replace(/\D/g, '');
	return digits.length === 3 || digits.length === 4;
};

export const cardFieldsComplete = (card, exp, cvv) =>
	cardNumberValid(card) && expirationValid(exp) && cvvValid(cvv);

export default cardFieldsComplete;
